import React, {useEffect, useState} from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';
import Image from '../../../Shared/Image/image';
import {DomainMarketCode, getMarketCode} from 'app/utilities/domain/domainConstants';
const EnterIdPartial = (props) => {
  /* Props:
   * - onChangeText: function(e) {...} where e is the event of TextInput's onChange. returns true if should be changed or no.
   * - onChangeType: function(isPassport) {...} where isPassport is true/false indicating whether it is a passport insert or not
   * - errorInForm: error to display. pass null if there is no error
   */

  const [inputVal, setInputVal] = useState('');
  const [isPassport, setIsPassport] = useState(false);
  const [isChooseOpen, setChooseOpen] = useState(false);
  const textPlaceholder = isPassport ? 'הכנס מספר דרכון' : 'הכנס מספר ת.ז / ח.פ';
  const isGolan = getMarketCode() == DomainMarketCode.GOLAN;

  const changeTextEvent = (e) => {
    if (props.onChangeText(e)) {
      setInputVal(e.target.value);
    }
  };
  const onChooseType = (val) => {
    if (val != isPassport) {
      setIsPassport(val);
      changeTextEvent({target: {value: ''}});

      props.onChangeType(val);
    }
    setChooseOpen(false);
  };

  if (!isGolan) {
    return (
      <>
        <TextInput
          placeholder={textPlaceholder}
          value={inputVal}
          maxLength={'9'}
          type='text'
          inputMode='numeric'
          error={props.errorInForm}
          onChange={changeTextEvent}
        />
      </>
    );
  } else {
    const passportChoiceMenu = (
      <div className='idPassportChoiceMenu'>
        <div
          className='chooseType'
          onClick={() => {
            onChooseType(false);
          }}>
          <div className='textDescriptionCombo'>
            <div className='primary'>ת.ז. או ח.פ.</div>
            <div className='secondary'>תעודת זהות ישראלית או ח.פ.</div>
          </div>
          {!isPassport && <Image style={{margin: '0 auto 0 0'}} src={require('./SVG/checkMark.svg')} />}
        </div>
        <div
          className='chooseType'
          onClick={() => {
            onChooseType(true);
          }}>
          <div className='textDescriptionCombo'>
            <div className='primary'>דרכון</div>
            <div className='secondary'>דרכון ישראלי או זר</div>
          </div>
          {isPassport && <Image style={{margin: '0 auto 0 0'}} src={require('./SVG/checkMark.svg')} />}
        </div>
      </div>
    );
    return (
      <div className='passportComboInput'>
        <TextInput
          placeholder={textPlaceholder}
          value={inputVal ? inputVal : ''}
          maxLength={isPassport ? '15' : '9'}
          type='text'
          inputMode={isPassport ? 'text' : 'numeric'}
          error={props.errorInForm}
          onChange={changeTextEvent}
        />
        <div className='separator'></div>
        <div
          className='idPassportChoice'
          onClick={() => {
            setChooseOpen(!isChooseOpen);
          }}>
          <span>{isPassport ? 'דרכון' : 'ת.ז.'}</span>
          <Image
            src={require('./SVG/chevronDown.svg')}
            className={isChooseOpen ? 'chevronDownIdCombo flippedIcon' : 'chevronDownIdCombo'}
          />
        </div>
        {isChooseOpen && passportChoiceMenu}
      </div>
    );
  }
};

export default EnterIdPartial;
